import { EXPERIENCE_LABELS, type Company, type Search } from "./types";

/**
 * Arma el texto del post de LinkedIn y devuelve el URL para abrir
 * el composer pre-cargado. Incluye el link público de postulación.
 */
export function buildLinkedInShareUrl(
  search: Search,
  company: Pick<Company, "name" | "rubro">,
  applyUrl: string
): string {
  const text = buildPostText(search, company, applyUrl);
  const url = new URL("https://www.linkedin.com/feed/");
  url.searchParams.set("shareActive", "true");
  url.searchParams.set("mini", "true");
  url.searchParams.set("text", text);
  return url.toString();
}

/** Devuelve el URL público de postulación para una búsqueda. */
export function buildApplyUrl(baseUrl: string, searchId: string): string {
  return `${baseUrl.replace(/\/$/, "")}/apply/${searchId}`;
}

function buildPostText(
  s: Search,
  company: Pick<Company, "name" | "rubro">,
  applyUrl: string
): string {
  const lines: string[] = [];
  lines.push(`Búsqueda activa: ${s.puesto}`);
  lines.push("");
  lines.push(`Empresa: ${company.name}${company.rubro ? ` · ${company.rubro}` : ""}`);
  lines.push(`Experiencia: ${EXPERIENCE_LABELS[s.experience]}`);

  if (s.salary_min || s.salary_max) {
    const range = formatRange(s);
    lines.push(`Rango salarial: ${range}`);
  }

  if (s.stack) {
    lines.push(`Stack: ${s.stack}`);
  } else if (s.technologies.length > 0) {
    lines.push(`Stack: ${s.technologies.join(", ")}`);
  }

  if (s.description && s.description.trim().length > 0) {
    lines.push("");
    // Trim para que entre cómodo en LinkedIn (max ~3000 chars total).
    const desc = s.description.trim();
    lines.push(desc.length > 600 ? desc.slice(0, 600) + "…" : desc);
  }

  lines.push("");
  lines.push("Para postularte haz click en el link:");
  lines.push(applyUrl);

  if (s.technologies.length > 0) {
    lines.push("");
    lines.push(s.technologies.map((t) => `#${t.replace(/\s+/g, "")}`).join(" "));
  }

  return lines.join("\n");
}

function formatRange(s: Search): string {
  const min = s.salary_min;
  const max = s.salary_max;
  const c = s.salary_currency;
  if (min && max) return `${c} ${formatNum(min)} - ${formatNum(max)}`;
  if (min) return `desde ${c} ${formatNum(min)}`;
  if (max) return `hasta ${c} ${formatNum(max)}`;
  return "";
}

function formatNum(n: number): string {
  return new Intl.NumberFormat("es-AR").format(n);
}
